<template>
<v-container fluid grid-list-xl>
  <div id="tableContainerBody">
    <div id="topContainer">
      <h2 id="bodyTitle">Notifications</h2>
      <button id="newTemplateButton" @click="openForm">New Notification</button>
    </div>
    <div id="tableContainer">
      <div id="chooseTableHeader">
        <div
          id="scheduledButton"
          class="filterButton"
          :class="{'selected': this.tableCategory === 'Scheduled'}"
          v-on:click="changeFilterAction('Scheduled')"
        >
          Scheduled
          <div
            :class="{'selectedheaderButtonBottom': this.tableCategory === 'Scheduled'}"
            class="headerButtonBottom"
          />
        </div>
        <div
          class="filterButton"
          :class="{'selected': this.tableCategory === 'Published'}"
          v-on:click="changeFilterAction('Published')"
        >
          Published
          <div
            :class="{'selectedheaderButtonBottom': this.tableCategory === 'Published'}"
            class="headerButtonBottom"
          />
        </div>
      </div>
      <NotificationTable v-bind:tableCategory="tableCategory" />
    </div>

    <modal name="notification-form-modal" @closed="beforeModalClose" @before-close="beforeModalClose">
      <div>
        <notification-form/>
      </div>
    </modal>
  </div>
  </v-container>
</template>

<script>
import NotificationTable from "./NotificationTable.vue";
import NotificationForm from "./NotificationForm.vue";

export default {
  name: "TableContainer",
  components: {
    NotificationTable,
    NotificationForm,
  },
  data() {
    return {
      tableCategory: "Scheduled",
    };
  },
  methods: {
    openForm() {
      this.show();
    },
    show() {
      this.$modal.show( NotificationForm,
      {
        isEditable: true
      },
      {
        width: '60%',
        clickToClose: false
      },
      {
        'before-close': this.beforeModalClose

      })
    },
    beforeModalClose(event) {
      console.log("close test", localStorage.delivery);
      if(localStorage.delivery == 0) {
        this.tableCategory = "Published"
      } else {
        this.tableCategory = "Scheduled"
      }
      // localStorage.delivery = 1; 
      this.getChild("NotificationTable").getNotifications();
      event.cancel;
    },
    getChild(name) {
      for (let child of this.$children)
        if (child.$options.name == name) return child;
    },
    changeFilterAction(filter) {
      this.tableCategory = filter;
    },
    onChildClick (value) {
      this.fromChild = value
    }
  },
  beforeMount() {},
};
</script>

<style scoped>
.headerButtonBottom {
  width: 40%;
  height: 3px;
  margin-top: 10px;
  background-color: white;
}
#newTemplateButton {
  width: 192px;
  height: 48px;
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(16, 156, 241, 0.24);
  background-color: #109cf1;
  color: white;
  font-size: 14px;
  border: none;
  margin-right: 30px;
}
#topContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 20px 20px;
}
#bodyTitle {
  text-align: left;
  font-weight: bold;
  margin-left: 30px;
  font-size: 16px;
  color: #191c23;
}
#chooseTableHeader {
  width: 100%;
  height: 60px;
  background-color: white;
  color: #767675;
  display: flex;
  justify-content: left;
  align-items: center;
}
#scheduledButton {
  margin-left: 20px;
  margin-right: 50px;
}
#tableContainer {
  width: 97%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#tableContainerBody {
  background-color: #f5f6f8;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding-top: 20px;
}
.filterButton {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.selected {
  color: #109cf1;
}
.selectedheaderButtonBottom {
  background-color: #109cf1;
}
.modal {
  width: 500px;
  margin: 0px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px 3px;
  transition: all 0.2s ease-in;
}
.fadeIn-enter {
  opacity: 0;
}
.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}
.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}
</style>
